import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaDownload } from "react-icons/fa";
import "../style/home.css";

function Executive() {
  const navigate = useNavigate();

  const [wings, setWings] = useState([]);
  const [floors, setFloors] = useState([]);
  const [flats, setFlats] = useState([]);

  const [selectedWing, setSelectedWing] = useState("");
  const [selectedFloor, setSelectedFloor] = useState("");
  const [selectedFlat, setSelectedFlat] = useState("");
  const [previousReading, setPreviousReading] = useState("");
  const [currentReading, setCurrentReading] = useState("");
  const [difference, setDifference] = useState("");
  const [uploaderName, setUploaderName] = useState("");
  const [uploaderContact, setUploaderContact] = useState("");
  const [billFile, setBillFile] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchWings = async () => {
      try {
        const response = await axios.get("https://api.lr.payplatter.in/api/wings");
        setWings(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching wings:", error);
        setError("Failed to load wings");
        setLoading(false);
      }
    };
    fetchWings();
  }, []);

   // Fetch Floors based on selected Wing
   useEffect(() => {
    if (!selectedWing) {
      setFloors([]);
      setSelectedFloor("");
      setFlats([]);
      setSelectedFlat("");
      return;
    }

    const fetchFloors = async () => {
      try {
        const response = await axios.get(`https://api.lr.payplatter.in/api/floors/wing/${selectedWing}`);
        setFloors(response.data);
      } catch (error) {
        console.error("Error fetching floors:", error);
        setFloors([]);
      }
    };

    fetchFloors();
  }, [selectedWing]);

    // Fetch Flats based on selected Floor
    useEffect(() => {
      if (!selectedFloor) {
        setFlats([]);
        setSelectedFlat("");
        return;
      }
  
      const fetchFlats = async () => {
        try {
          const response = await axios.get(`https://api.lr.payplatter.in/api/flats/floor/${selectedFloor}`);
          setFlats(response.data);
        } catch (error) {
          console.error("Error fetching flats:", error);
          setFlats([]);
        }
      };
  
      fetchFlats();
    }, [selectedFloor]);

    useEffect(() => {
      if (!selectedFlat) {
        setPreviousReading("");
        return;
      }
  
      const fetchPreviousReading = async () => {
        try {
          const response = await axios.get(`https://api.lr.payplatter.in/api/meter-readings/${selectedFlat}/previous`);
          setPreviousReading(response.data.previousReading || ""); // Ensure it's properly handled
        } catch (error) {
          console.error("Error fetching previous reading:", error);
          setPreviousReading("");
        }
      };
  
      fetchPreviousReading();
    }, [selectedFlat]);

    const handleWingChange = (e) => {
      setSelectedWing(e.target.value);
      setSelectedFloor("");
      setSelectedFlat("");
    };
  
    const handleFloorChange = (e) => {
      setSelectedFloor(e.target.value);
      setSelectedFlat("");
    };
  
    const handleFlatChange = (e) => {
      setSelectedFlat(e.target.value);
    };

  const handleProceed = () => {
    if (!selectedWing || !selectedFloor || !selectedFlat) {
      alert("Please select Wing, Floor, and Flat No.");
      return;
    }

    // Generate dummy previous reading
    // const prevReading = Math.floor(Math.random() * 900) + 100; // Between 100 - 1000
    // setPreviousReading(prevReading);

    setShowForm(true);
  };

  const handleCurrentReadingChange = (e) => {
    const value = e.target.value;
    setCurrentReading(value);
    setDifference(value ? parseFloat(value) - previousReading : "");
  };

  

  const handleUploaderContactChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) {
      setUploaderContact(value);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileType = file.type;
      const fileSize = file.size / 1024 / 1024; // Convert to MB
      if ((fileType === "image/jpeg" || fileType === "image/png") && fileSize <= 1) {
        setBillFile(file);
      } else {
        alert("Please upload a JPG or PNG file under 1MB.");
        e.target.value = ""; // Reset file input
      }
    }
  };

  // const handleSubmit = () => {
  //   if (!currentReading || !uploaderName || uploaderContact.length !== 10 || !billFile) {
  //     alert("Please fill all fields correctly before submitting.");
  //     return;
  //   }

  //   navigate("/confirmation", {
  //     state: {
  //       wing: selectedWing,
  //       flat: selectedFlat,
  //       mobileNumber: uploaderContact,
  //       name: uploaderName,
  //       previousReading,
  //       currentReading,
  //       waterUsage: difference,
  //       uploaderName,
  //       uploaderContact,
  //       billFileName: billFile.name,
  //     },
  //   });
  // };

  // // Generate flat numbers based on selected floor
  // const getFlatsForFloor = () => {
  //   if (!selectedFloor) return [];
  //   const floorNumber = parseInt(selectedFloor * 10);
  //   return Array.from({ length: 8 }, (_, i) => `${floorNumber}${i + 1}`);
  // };

  const handleSubmit = async () => {
    if (!currentReading || !uploaderName || uploaderContact.length !== 10 || !billFile) {
      alert("Please fill all fields correctly before submitting.");
      return;
    }

    const formData = new FormData();
    formData.append("wingId", selectedWing);
    formData.append("flatNo", selectedFlat);
    formData.append("previousReading", previousReading);
    formData.append("currentReading", currentReading);
    formData.append("uploaderName", uploaderName);
    formData.append("uploaderContact", uploaderContact);
    formData.append("file", billFile);

    console.log(selectedWing);
    console.log(selectedFlat);
    console.log(currentReading);
    console.log(uploaderName);
    console.log(uploaderContact);
    


    try {
      const response = await axios.post(
        `https://api.lr.payplatter.in/api/meter-readings/add`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.status === 200) {
        alert("File uploaded successfully!");
        navigate("/confirmation", {
          state: {
            wing: selectedWing,
            flat: selectedFlat,
            mobileNumber: uploaderContact,
            name: uploaderName,
            previousReading,
            currentReading,
            waterUsage: difference,
            billFileName: billFile.name,
          },
        });
      } else {
        alert("Failed to upload file. Please try again.");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      alert("An error occurred while submitting. Please try again.");
    }
  };

  // PWA Install
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isInstallable, setIsInstallable] = useState(false);
  
    useEffect(() => {
      const handleBeforeInstallPrompt = (e) => {
        e.preventDefault();
        setDeferredPrompt(e);
        setIsInstallable(true);
      };
  
      window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
  
      return () => {
        window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      };
    }, []);
  
    const handleInstall = () => {
      if (deferredPrompt) {
        deferredPrompt.prompt();
        deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the PWA install prompt');
          } else {
            console.log('User dismissed the PWA install prompt');
          }
          // Clear the deferredPrompt after installation
          setDeferredPrompt(null);
          setIsInstallable(false);
        });
      }
    };

  return (
    <div className="home-container">
      <nav className="navbar">
        <div className="logo">💧</div>
      </nav>
       {isInstallable && (
                <button
                  id="install-button"
                  onClick={handleInstall}
                  className="login-btn"
                  style={{ padding: "12px 5px", width: "150px", background: "green" }}
                >
                  <FaDownload /> Install PWA
                </button>
              )}

      <div className="contents">
        <div className="text-content">
          <h2 className="special">Water Reading Entry</h2>

          {/* Wing Dropdown */}
          <div className="form-group">
            <label className="form-label">Select Building:</label>
            {loading ? (
              <p>Loading Building...</p>
            ) : error ? (
              <p style={{ color: "red" }}>{error}</p>
            ) : (
              <select className="dropdown" value={selectedWing} onChange={handleWingChange} disabled={showForm}>
                <option value="">Select Building</option>
                {wings.map((wing) => (
                  <option key={wing.id} value={wing.id}>
                    {wing.name}
                  </option>
                ))}
              </select>
            )}
          </div>

          {/* Floor Dropdown */}
          {!showForm && (
            <div className="form-group">
            <label className="form-label">Select Floor:</label>
            <select className="dropdown" value={selectedFloor} onChange={handleFloorChange} disabled={showForm}>
              <option value="">Select Floor</option>
              {floors.map((floor) => (
                <option key={floor.id} value={floor.id}>
                  {floor.floorNo}
                </option>
              ))}
            </select>
          </div>
          )}

          {/* Flat Dropdown */}
          <div className="form-group">
            <label className="form-label">Select Flat No.:</label>
            <select className="dropdown" value={selectedFlat} onChange={handleFlatChange} disabled={showForm}>
              <option value="">Select Flat</option>
              {flats.map((flat) => (
                <option key={flat.id} value={flat.flatNo}>
                  {flat.flatNo}
                </option>
              ))}
            </select>
          </div>

          {/* Proceed Button */}
          {!showForm && (
            <button className="fetch-btn" onClick={handleProceed}>
              Proceed
            </button>
          )}

          {/* Form after Proceed */}
          {showForm && (
            <>
               <div className="form-group">
                <label className="form-label">Previous Reading:</label>
                <input type="text" className="input-box" value={previousReading} readOnly />
              </div>

              <div className="form-group">
                <label className="form-label">Enter Current Reading:</label>
                <input type="number" className="input-box" value={currentReading} onChange={handleCurrentReadingChange} />
              </div>

              <div className="form-group">
                <label className="form-label">Difference:</label>
                <input type="text" className="input-box" value={difference} readOnly />
              </div>

              <div className="form-group">
                <label className="form-label">Upload Image:</label>
                <input type="file" className="file-input" accept="image/jpeg, image/png" onChange={handleFileChange} />
              </div>

              <div className="form-group">
                <label className="form-label">Uploader Name:</label>
                <input type="text" className="input-box" value={uploaderName} onChange={(e) => setUploaderName(e.target.value)} />
              </div>

              <div className="form-group">
                <label className="form-label">Uploader Contact:</label>
                <input type="text" className="input-box" value={uploaderContact} onChange={handleUploaderContactChange} />
              </div>

              <button className="confirm-btns" onClick={handleSubmit}>
                Submit
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Executive;
